module.exports = __webpack_public_path__ + "img/jk7.d19a7ad8.png";